import { Box, Button, Grid, makeStyles, Theme, Typography } from "@material-ui/core";

import { colors } from "swyft-react-core";
import { CreditCardIcon } from "../../../components/Icons";
import { Link as RouterLink } from "react-router-dom";

import { createPaymentSession } from "../../../api/SwyftApi";
import { loadStripe } from "@stripe/stripe-js";
import { Quote } from "../../../api/Quote/Quote";
import { toast } from "react-toastify";
import { EEventType, eventAnalytic } from "../../../app/analytics";
import { FeatureConfigStripeKey, FeaturePaymentDeposit } from "../../../app/consts";
import { useConfig } from "../../../components/config/ConfigContext";

// const stripePromise = ;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: colors.lighterGrey
  },
  button: {
    "width": "90%",
    "maxWidth": "18.5rem",
    "& .Swyft-icon": {
      marginRight: theme.spacing(1)
    }
  },
  humm: {
    height: "25px",
    marginRight: theme.spacing(1)
  }
}));

interface Props {
  quote: Quote;
  stateTerm: boolean;
  onPay: Function;
}

const QuoteCartPayment = ({ quote, stateTerm, onPay }: Props) => {
  const classes = useStyles();

  const { isFeatureEnabled, getFeatureConfigValue } = useConfig();

  if (!isFeatureEnabled(FeaturePaymentDeposit)) {
    return <></>;
  }

  const handleStripeCheckout = async () => {
    await onPay();
    console.log("Stripe checkout");

    eventAnalytic.record(EEventType.StripeGateWayInit);

    const stripe = await loadStripe(getFeatureConfigValue(FeaturePaymentDeposit, FeatureConfigStripeKey));
    const checkoutResponse = await createPaymentSession(quote.id);

    const result = await stripe!.redirectToCheckout({
      sessionId: checkoutResponse.stripeSessionId
    });

    if (result.error) {
      toast.error("Unable to raise payment, please try again");
      console.log(result.error.message);
    }
  };

  return (
    <Box py={2}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12}>
          <Button
            color="secondary"
            variant="contained"
            className={classes.button}
            onClick={handleStripeCheckout}
            disabled={!stateTerm}
          >
            <CreditCardIcon iconColor={colors.white} />
            <Typography variant="body1" component="span">
              Pay €{quote.depositRequirement} Deposit
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button
            component={RouterLink}
            to="/finance"
            onClick={() => {
              eventAnalytic.record(EEventType.FlexifyGateWayInit);
            }}
            color="secondary"
            variant="outlined"
            className={classes.button}
            disabled={!stateTerm}
          >
            <img src="images/humm_logo.png" alt="Humm" className={classes.humm} />
            <Typography variant="body1" component="span">
              Flexible&nbsp;Payments&nbsp;via&nbsp;Humm
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuoteCartPayment;
